import { useState, useEffect } from 'react';

const WHATSAPP_URL =
  'https://wa.me/905301714669?text=Merhaba%20SARA%20KUYUMCULUK%2C%20%C3%B6zel%20bir%20tasar%C4%B1m%20talep%20etmek%20istiyorum.';

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);
  const [tooltip, setTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div
        className={`fixed bottom-8 right-6 z-50 flex flex-col items-end gap-3 transition-all duration-700 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Tooltip */}
        {tooltip && (
          <div className="bg-luxury-card border border-gold/30 px-4 py-2 rounded-sm max-w-[200px] text-right">
            <p className="font-sans text-white text-xs leading-relaxed">
              Tasarımınızı WhatsApp&apos;tan hızlıca paylaşın!
            </p>
          </div>
        )}

        {/* Button */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="nofollow noreferrer"
          onMouseEnter={() => setTooltip(true)}
          onMouseLeave={() => setTooltip(false)}
          aria-label="WhatsApp ile iletişim"
          className="relative w-14 h-14 flex items-center justify-center rounded-full cursor-pointer group"
          style={{
            background: 'linear-gradient(135deg, #C9A057 0%, #E2C07A 50%, #9A7A3A 100%)',
          }}
        >
          <i className="ri-whatsapp-line text-luxury-black text-2xl" />
          {/* Pulse ring */}
          <span className="absolute inset-0 rounded-full animate-ping opacity-20"
            style={{ background: 'linear-gradient(135deg, #C9A057, #E2C07A)' }}
          />
        </a>
      </div>

      {/* Sticky bottom CTA – mobile */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-luxury-black/95 border-t border-luxury-border px-4 py-3">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="nofollow noreferrer"
          className="btn-gold w-full py-3.5 text-xs rounded-sm whitespace-nowrap flex items-center justify-center gap-2"
        >
          <i className="ri-whatsapp-line text-base" />
          Tasarımını Hemen Başlat
        </a>
      </div>
    </>
  );
}
